<template>
  <v-card
    elevation="2"
    outlined
    flat
    style="font-family: 'Poppins', sans-serif !important"
  >
    <v-row v-if="dataLoading">
      <v-col>
        <v-skeleton-loader type="list-item-three-line" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="actions" />
      </v-col>
    </v-row>
    <v-col v-else>
      <v-row v-if="!$vuetify.breakpoint.xs">
        <v-col
          align-self="center"
          class="ml-3 pr-4"
          cols="3"
          md="1"
          sm="2"
          xs="8"
        >
          <v-col style="white-space: nowrap" class="pa-0 ma-0" cols="12">
            {{ getTime(new Date(sessionData.StartDate._seconds * 1000)) }}
          </v-col>
          <v-col style="white-space: nowrap" class="pa-0 ma-0" cols="12">
            {{ getTime(new Date(sessionData.EndDate._seconds * 1000)) }}
          </v-col>
        </v-col>
        <v-col class="ml-4">
          <v-row no-gutters>
            <v-col cols="4" md="2" sm="4">
              <v-img
                width="125"
                max-width="400"
                style="border-radius: 5px"
                :aspect-ratio="14 / 9"
                :src="
                  sessionData
                    ? sessionData.SessionLogo
                      ? sessionData.SessionLogo
                      : '../../assets/e2medu/default-session.jpg'
                    : '../../assets/e2medu/default-session.jpg'
                "
              />
            </v-col>
            <v-col align-self="center" class="pl-2">
              <v-row
                ><v-icon
                  :color="
                    getStatus == 'Live'
                      ? '#6cb649'
                      : getStatus == 'Ended'
                      ? '#b9bec1'
                      : '#fcc53f'
                  "
                  size="10"
                  >stop_circle</v-icon
                ><span class="pl-2 py-0 session-status">{{
                  getStatus
                }}</span></v-row
              >
              <v-row class="pt-1"
                ><span class="text-h5"></span
                >{{ sessionData.eventInfo.EventFullName }}
              </v-row>
              <v-row class="mt-0 pt-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text-h6 session-name"
                      style="width: 100% !important"
                      v-bind="attrs"
                      v-on="on"
                      >{{
                        sessionData.Name
                          ? sessionData.Name.substring(0, 25) +
                            (sessionData.Name.length >= 25 ? "..." : "")
                          : ""
                      }}</span
                    >
                  </template>
                  <span>{{ sessionData.Name }}</span>
                </v-tooltip>
              </v-row>
            </v-col>
            <v-col cols="4" align-self="center">
              <div
                class="pr-3"
                style="width: inherit; display: flex; justify-content: flex-end"
              >
                <div
                  v-if="
                    reviewsLoaded &&
                    getStatus == 'Ended' &&
                    $store.state.user[0].userType == 'Attendee'
                  "
                >
                  <v-tooltip v-if="studentRating || teacherRating" bottom>
                    <template
                      v-if="studentRating || teacherRating"
                      v-slot:activator="{ on, attrs }"
                    >
                      <div
                        v-on="on"
                        v-bind="attrs"
                        class="pr-2"
                        @click.stop="rateThisSession(sessionData)"
                      >
                        <v-rating
                          v-on="on"
                          v-bind="attrs"
                          v-model="rating"
                          readonly
                          color="yellow darken-3"
                          background-color="grey darken-1"
                          empty-icon="$ratingFull"
                          half-increments
                          hover
                          size="24"
                        ></v-rating>
                      </div>
                    </template>
                    <span>Session Rating</span>
                  </v-tooltip>
                  <div class="pr-3" v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="rateThisSession(sessionData)"
                          icon
                          ><v-icon>star_rate</v-icon></v-btn
                        >
                      </template>
                      <span>Rate this Session</span>
                    </v-tooltip>
                  </div>
                </div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-hover v-slot="{ hover }">
                      <v-btn
                        @click.stop="
                          getStatus == 'Ended'
                            ? joinNow(sessionData, true)
                            : joinNow(sessionData, false)
                        "
                        v-bind="attrs"
                        v-on="on"
                        :loading="submitLoader"
                        color="#6cb649"
                        class="btn-common"
                        :disabled="getStatus != 'Live' && getStatus != 'Ended'"
                        :dark="
                          getStatus == 'Live' || getStatus == 'Ended'
                            ? !hover
                            : false
                        "
                        >{{
                          getStatus == "Ended" ? "Watch Now" : "Join Now"
                        }}</v-btn
                      >
                    </v-hover>
                  </template>
                  <span>{{
                    getStatus == "Ended"
                      ? "Click here to watch now"
                      : "Click here to join the class"
                  }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col v-if="$vuetify.breakpoint.xs">
        <v-row class="ml-5">
          <v-col>
            {{ getTime(new Date(sessionData.StartDate._seconds * 1000)) }}
          </v-col>
          <v-col>
            {{ getTime(new Date(sessionData.EndDate._seconds * 1000)) }}
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-img
            width="125"
            max-width="400"
            style="border-radius: 5px"
            :aspect-ratio="14 / 9"
            src="../../assets/e2medu/default-session.jpg"
          ></v-img>
        </v-row>
        <v-row>
          <v-col>
            <v-row
              ><v-icon
                :color="
                  getStatus == 'Live'
                    ? '#6cb649'
                    : getStatus == 'Ended'
                    ? '#b9bec1'
                    : '#fcc53f'
                "
                size="10"
                >stop_circle</v-icon
              ><span class="pl-2 session-status">{{ getStatus }}</span></v-row
            >
            <v-row class="pt-1"
              ><span class="text-h5"></span
              >{{ sessionData.eventInfo.EventFullName }}
            </v-row>
            <v-row class="mt-0 pt-1"
              ><span class="text-h6 session-name">{{
                sessionData.Name
              }}</span></v-row
            >
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <div
            class="pr-0"
            style="width: inherit; display: flex; justify-content: flex-end"
          >
            <v-hover v-slot="{ hover }">
              <v-btn
                @click.stop="
                  getStatus == 'Ended' ? joinNow(sessionData, true) : joinNow()
                "
                :loading="submitLoader"
                color="#6cb649"
                class="btn-common"
                :disabled="getStatus == 'Live' ? false : true"
                :dark="getStatus == 'Live' ? !hover : false"
                >Join Now</v-btn
              >
            </v-hover>
          </div>
        </v-row>
      </v-col>
    </v-col>
  </v-card>
</template>

<script>
import store from "../../store/index";
import apiHandler from "../../handler/edu_handler";
import helper from "../../helper/_helper";
var CLIENT_ID = store.state.client[0].id;
const INSTANCE_ID = process.env.VUE_APP_INSTANCE_ID;
import APIs from "../../components/APIInit";
import axios from "axios";
import { bus } from "@/main";
export default {
  data() {
    return {
      ratedDate: null,
      reviewsLoaded: false,
      rating: 0,
      ratingText: "",
      teacherRating: "",
      studentRating: "",
      submitLoader: false,
      dataLoading: false,
      currentTime: new Date().getTime(),
      status: "",
      zoomDetails: {},
    };
  },
  computed: {
    getStatus: function () {
      if (
        (this.sessionData.StartDate._seconds - 10 * 60) * 1000 <=
          this.currentTime &&
        this.currentTime <= (this.sessionData.EndDate._seconds + 30 * 60) * 1000
      ) {
        return "Live";
      } else if (this.currentTime >= this.sessionData.EndDate._seconds * 1000) {
        return "Ended";
      } else {
        return "Upcoming";
      }
    },
  },
  created() {
    let self = this;
    setInterval(function () {
      self.currentTime = Date.now();
    }, 1000);
  },
  props: {
    sessionData: { type: Object, default: () => {} },
    sessionId: { type: String, default: "" },
    eventId: { type: String, default: "" },
    isHost: { type: Boolean, default: false },
    clientSettings: { type: Object, default: () => {} },
  },
  mounted() {
    CLIENT_ID = store.state.client[0].id;
    let reqBody = {};

    reqBody = {
      key: {
        sessionId: this.sessionId,
        clientId: CLIENT_ID,
        eventId: this.eventId,
        isTeacher: false,
      },
      data: {
        userId: this.$store.state.user[0].id,
      },
    };

    this.reviewsLoaded = false;
    apiHandler
      .getReviews(reqBody)
      .then((res) => {
        if (this.isHost) {
          this.teacherRating = res.data;
          this.ratingText = res.data.ratingText;
          this.ratedDate = res.data.date;
          this.rating = parseFloat(res.data.stars);
        } else {
          this.studentRating = res.data;
          this.ratingText = res.data.ratingText;
          this.ratedDate = res.data.date;
          this.rating = parseFloat(res.data.stars);
        }
        this.reviewsLoaded = true;
      })
      .catch(() => {
        this.reviewsLoaded = true;
      });
  },
  methods: {
    registerUserToZoom(userData, zoomData) {
      bus.$emit("toggleLoader", true);
      let headers = {
        Authorization: "Bearer " + this.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        email: userData.Email,
        name: userData.name,
        first_name: userData.fname,
        last_name: userData.lname,
        meetingid: zoomData.id,
      };
      axios
        .post(APIs.AddAttendeesToZoom, requestData, {
          headers: headers,
        })
        .then((response) => {
          debugger;
          if (
            response &&
            response.data &&
            response.data.status == 0 &&
            response.data.data.id &&
            response.data.data.join_url &&
            response.data.data.join_url != ""
          ) {
            bus.$emit("toggleLoader", false);
            window.open(response.data.data.join_url, "_blank");
            //self.postLeaderboardAction("SNVW");
            // this.$router.replace({
            //   path: "/mainlobby" + "/session_cal",
            //   query: { feedbackBeforeExpire: true },
            // });
          } else {
            //self.retryJoinInZoomPopup();
          }
        })
        .catch((error) => {
          console.log(error);
          //self.retryJoinInZoomPopup();
        });
    },
    rateThisSession(sessionData) {
      // if (this.isHost) return;
      // else {
      sessionData.rating = this.rating ? this.rating : "";
      sessionData.ratingText = this.ratingText ? this.ratingText : "";
      sessionData.ratedDate = this.ratedDate ? this.ratedDate : "";
      this.$emit("rateMe", sessionData);
      // }
    },
    sendMessage(sessionDetails) {
      if (!sessionDetails.isHost) {
        let senderName = this.$store.state.user[0].name;
        let sessionName = sessionDetails.Name;
        let recieverName = sessionDetails.MappedHosts[0].Name;
        let recieverId = sessionDetails.MappedHosts[0].AttendeeId;
        let body = `Dear ${recieverName},${senderName}(Student) has joined your class ${sessionName} of course ${sessionDetails.eventInfo.EventFullName}`;
        const msg = {
          userId: [recieverId],
          body: body,
          messagetype: "session joined",
        };
        apiHandler.sendMessage(msg);
      }
    },
    sendMail(sessionDetails) {
      let to = "";
      var from;
      if (location.host.includes("edulife"))
        from = { email: "support@edulife.sg", name: "EduLife SG" };
      else from = { email: "support@mastry.io", name: "Team Mastry" };
      let cc = "";
      let senderName = "";
      let recieverName = "";
      let sessionName = sessionDetails.Name;
      let eventName = sessionDetails.eventInfo.EventFullName;
      if (sessionDetails.isHost) {
        if (location.host.includes("edulife")) {
          to = "sessionalerts@edulife.sg";
          recieverName = "EduLife SG";
          // cc = "sessionalerts@edulife.sg";
        } else {
          to = "students@mastry.io";
          recieverName = "Mastry Alerts";
          cc = "vivek.somani@webspiders.com";
        }

        senderName = this.$store.state.user[0].name + "(Teacher)";
      } else {
        recieverName = sessionDetails.MappedHosts[0].Name;
        senderName = this.$store.state.user[0].name + "(Student)";
        to = sessionDetails.MappedHosts[0].Email;
        if (location.host.includes("edulife")) cc = "sessionalerts@edulife.sg";
        else cc = "ops@mastry.io";
      }
      var html;
      if (location.host.includes("edulife"))
        html = `<html><body><p>Dear ${recieverName},</p></br>${senderName} has joined the class <b>${sessionName}</b> of course <b>${eventName}</b>.</br></br><p>Thank you! </p></br>Team EduLife</body></ html>`;
      else
        html = `<html><body><p>Dear ${recieverName},</p></br>${senderName} has joined the class <b>${sessionName}</b> of course <b>${eventName}</b>.</br></br><p>Thank you! </p></br>Team Mastry</body></ html>`;
      let subject = `${
        sessionDetails.isHost
          ? "Teacher joined the class"
          : "Student joined your class"
      }`;
      let mailObject = { to, from, html, subject };
      if (cc) mailObject.bcc = cc;
      if (location.host.includes("edulife"))
        mailObject.replyTo = "sessionalerts@edulife.sg";
      else mailObject.replyTo = "support@mastry.io";
      console.log("mailObject>>>>>>>>>", mailObject);

      apiHandler.sendMail(mailObject);
    },
    routeToZoom(onDemand) {
      let analyticsObject = {
        eventId: this.sessionData.eventInfo.EventId,
        action: "Join Session",
        actionLabel: "Join Now",
        actionType: "view",
        pageName: this.$route.name,
        eventName: this.sessionData.eventInfo.EventFullName,
      };
      apiHandler.sendEventAnalytics(analyticsObject);

      if (onDemand) {
        setTimeout(() => {
          this.submitLoader = false;
        }, 2500);
        if (
          this.zoomDetails.Zoom_Detail &&
          this.zoomDetails.Zoom_Detail.start_url
        ) {
          this.sessionData.Zoom_Detail = this.zoomDetails.Zoom_Detail;
        }
        this.$emit("onDemand", this.sessionData);
      } else {
        this.$store.commit("setFeedbackLastSession", this.sessionData);

        this.sendMail(this.sessionData);
        this.sendMessage(this.sessionData);
        this.submitLoader = false;
        if (this.isHost) {
          this.$emit("zoomDialogEmit", true);
          setTimeout(() => {
            this.$emit("zoomDialogEmit", false);
            window.open(
              this.zoomDetails.Zoom_Detail.start_url +
                "&uname=" +
                this.$store.state.user[0].name.trim()
            );
            // this.$router.replace({
            //   path: "/mainlobby" + "/session_cal",
            //   query: { feedbackBeforeExpire: true },
            // });
          }, 10000);
        } else {
          // this.registerUserToZoom(
          //   this.$store.state.user[0],
          //   this.zoomDetails.Zoom_Detail
          // );
          window.open(
            this.zoomDetails.Zoom_Detail.join_url +
              "&uname=" +
              this.$store.state.user[0].name.trim()
          );
        }
      }
    },
    async joinNow(data, onDemand = false) {
      console.log("data====", data);
      console.log("onDemand====", onDemand);
      this.submitLoader = true;
      if (data.StreamingClient == "Web") {
        this.submitLoader = false;
        //bus.$emit("toggleAgora", data);
        this.openJoinSessionDialog(data);
      } else {
        if (
          data.SessionTypeDetails.RoundTableTopic &&
          data.SessionTypeDetails.RoundTableTopic.TopicId
        ) {
          apiHandler
            .getZoomMeetingDetails({
              instanceId: INSTANCE_ID,
              clientId: CLIENT_ID,
              eventId: this.eventId,
              topicId: data.SessionTypeDetails.RoundTableTopic.TopicId,
            })
            .then((res) => {
              this.zoomDetails = res.data.data;
              this.routeToZoom(onDemand);
            });
        } else {
          this.zoomDetails.Zoom_Detail = data.Zoom_Detail;
          this.routeToZoom(onDemand);
        }
      }
    },
    openJoinSessionDialog(data) {
      // self.playerKey++;
      // self.playerDialog = true;
      // self.dialogSessionId = sessionId;
      bus.$emit("openPlayerDialog", {
        roomId: data.SessionId,
        sessionId:  data.SessionId,
        memberIDs: [],
        attendees: [],
        sendChat: false,
        sendNotification: false,
        eventId: data.eventId,
        eventName: "",
        eventCollectionName: data.eventInfo.EventCollectionName,
      });
    },
    getTime(date) {
      if (!date) return "";
      return helper.getTime(date);
    },
    populateApiData() {
      this.dataLoading = true;
      let apiObject = {
        instanceId: INSTANCE_ID,
        clientId: CLIENT_ID,
        eventId: this.eventId,
        sessionId: this.sessionId,
      };
      if (this.eventId && this.sessionId) {
        apiHandler
          .getSessionDetails(apiObject)
          .then((result) => {
            this.sessionData = result.data.data;
            this.sessionData.eventId = this.eventId;
            this.dataLoading = false;
          })
          .catch((err) => {
            this.dataLoading = false;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style scope>
.v-rating .v-icon {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.material-icons {
  font-family: "Material Icons" !important;
}
.v-application .text-h6.session-name {
  font-weight: 600;
  font-size: 18px !important;
  font-family: Poppins, sans-serif !important;
}
.theme--light.v-card {
  color: #000000;
}
.v-application .elevation-2 {
  box-shadow: 0 1px 6px 0 rgb(28 28 28 / 10%) !important;
  border: 0;
  margin-bottom: 10px;
}
.v-btn.btn-common {
  min-width: 125px !important;
  padding: 8px 15px;
  font-size: 14px;
  box-shadow: none;
  font-weight: 600;
  letter-spacing: inherit;
  height: 40px !important;
}
.session-status {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  color: #5d5d5d;
}
.v-application .v-picker--date .primary {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  font-size: 16px;
  color: #000;
  padding-bottom: 0;
}
.v-date-picker-title .v-date-picker-title__date {
  font-size: 16px;
  padding-left: 16px;
}
.v-picker--date .v-date-picker-title {
  justify-content: center;
  flex-direction: row;
}
.v-picker--date .v-date-picker-header__value button {
  font-weight: 600;
}
.v-picker--date .v-date-picker-table .v-btn {
  color: #000000;
  font-weight: 500;
  height: 26px;
}
.v-application .v-picker--date .accent {
  height: 32px;
  border-radius: 5px;
  border: 0px;
  background-color: #3c4852 !important;
  border-color: #3c4852 !important;
}
.v-picker__body.theme--light {
  width: 236px !important;
}
.v-tab {
  letter-spacing: initial;
}
.theme--light.v-divider {
  border-color: #e6e8ea !important;
}
.v-picker__body .v-date-picker-table {
  padding: 0;
}
.v-picker--date .v-date-picker-table .v-btn:hover {
  border-radius: 5px;
}
.v-date-picker-table .v-btn.v-btn--active {
  color: #fff !important;
}
.font-style-routes {
  color: #000;
}
hr {
  border-top: 2px solid red;
  border-radius: 2px;
}
</style>
